export enum FluxAntaiSortOptions {
  'DATE_APPEL' = 'DATE_APPEL',
  'INDEX_DEBUT' = 'INDEX_DEBUT',
  'INDEX_FIN' = 'INDEX_FIN',
}
